
import { INCOME_TYPES } from '@constants/ssap/hhmTypes/incomeAndExpenceTypes';

// Types

import { Income } from '@components/ssap/SsapTypes';

const combinedFilterByType = (...filters) => {
    return entry => {
        return filters.every(filter => filter(entry));
    };
};

const removeDummyType: Function = (entry: Income): boolean => entry.type !== INCOME_TYPES.DUMMY;
const removeSocialSecurityType: Function = (entry: Income): boolean => entry.type !== INCOME_TYPES.SOCIAL_SECURITY_DISABILITY;
const removeUnemploymentType: Function = (entry: Income): boolean => entry.type !== INCOME_TYPES.UNEMPLOYMENT;

export const filterTools: { [key: string] : Function } = {
    combinedFilterByType,
    removeDummyType,
    removeSocialSecurityType,
    removeUnemploymentType
};